export default __webpack_public_path__ + "static/media/BO.7db984a5.png";